import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { PTTypography } from "../../../common/components/ui";
import ChangePasswordComponent from "./ChangePasswordComponent";
import { useAuth } from "../../../common/provider";
import { useEffect, useState } from "react";

export const ChangePasswordDialog = (props) => {
  const {
    title,
    description,
    open,
    actions = [],
    onConfirm,
    onCancel,
    onClose,
    dialogStyle,
    descriptionStyle,
    titleStyle,
    ...otherProps
  } = props;

  const {
    needsPasswordChange,
    setShowChangePasswordDialog,
    showChangePasswordDialog,
  } = useAuth();
  const [dismissedForSession, setDismissedForSession] = useState(false);

  useEffect(() => {
    if (
      needsPasswordChange &&
      !showChangePasswordDialog &&
      !dismissedForSession
    ) {
      setShowChangePasswordDialog(true);
    }
  }, [
    needsPasswordChange,
    showChangePasswordDialog,
    setShowChangePasswordDialog,
    dismissedForSession,
  ]);

  const handleClose = () => {
    setShowChangePasswordDialog(false);
    setDismissedForSession(true);
  };

  return (
    <Dialog
      open={showChangePasswordDialog}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle sx={{ ...(titleStyle || {}) }}>
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <PTTypography
            variant="h6"
            component="h1"
            sx={{
              fontSize: "17.84px",
              color: "#232A56",
            }}
          >
            change.password.warning
          </PTTypography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pl: 6, pr: 6, pb: 5 }}>
        <ChangePasswordComponent />
      </DialogContent>
    </Dialog>
  );
};

export default ChangePasswordDialog;
